import { useQuery } from "@tanstack/react-query";
import {
  FrontendFilesApi,
  FrontendFilesApi$TreeOfFileResult,
} from "@/custolink-transpiled_by_server/bc.asset_files.api_methods";


import useUiContext from "@/custolink-hooks/useUiContext";
import { useMemo, useState } from "react";
import { AssetViewDetails } from "@/custolink-views/asset_frontend/asset_view/useAssetViewFacade";

export type UseAssetFileBrowserReturn = {
  isLoading: boolean;
  tree: Array<FrontendFilesApi$TreeOfFileResult>|null,
  /**
   * Asset or folder protection hid something from this visitor. Says nothing
   * about what or how much; the empty state uses it to point to signing in.
   */
  hiddenByProtection: boolean,
  currentTreeLevel: Array<FrontendFilesApi$TreeOfFileResult>,
  breadcrumb:string,
  select:(name:string) => void,
  back:()=>void
};

export default function useAssetFileBrowser(
  assetViewDetails: AssetViewDetails,
  assetComponentId: number,
): UseAssetFileBrowserReturn {

  const uic = useUiContext();
  const [breadcrumb,setBreadcrumb] = useState("")

  const query = useQuery({
    enabled: assetComponentId != null,
    queryFn: () => {
      return FrontendFilesApi.getFilesForAssetPageComponent(
        uic.organisationContext.organisationId,
        assetComponentId,
        assetViewDetails.urlParamsForRequests.viewId,
        assetViewDetails.urlParamsForRequests.viewValue,
        assetViewDetails.urlParamsForRequests.assetId,
      )
    },
    queryKey: [
      "FrontendFilesApi",
      FrontendFilesApi.getFilesForAssetPageComponent.name,
      uic._orgId+"_"+assetComponentId+"_"+assetViewDetails.urlParamsForRequests.keyString,
      // protection decides per visitor: a new identity must ask the server again
      uic.assetFrontendAuthedUser?.username ?? "",
    ]
  });

  const currentLevel = useMemo(()=>{
    const tree = query.data?.tree
    if(tree == null || breadcrumb == ""){
      return query?.data?.tree ?? []
    } else {
      const b = breadcrumb.split("/")
      let current = tree
      for(let i = 0; i < b.length; i++){
        const tt = current.find(s => s.name == b[i])
        if(tt != null){
          current = tt.children
        } else {
          return []
        }
      }
      return current
    }
  },[breadcrumb,query.data])

  //console.log("br", breadcrumb)
  //console.log("tree", query?.data?.tree)
  //console.log("currentTreeLevel", currentLevel)

  return {
    isLoading: query.isFetching,
    tree: query.data?.tree ?? null,
    hiddenByProtection: query.data?.hiddenByProtection === true,
    currentTreeLevel: currentLevel,
    breadcrumb:breadcrumb,
    select: (name:string)=> {
      setBreadcrumb(b => {
        if(b == ""){
          return name
        } else {
          return b+"/"+name
        }
      })
    },
    back: () => {
      setBreadcrumb(b => {
        if(b == ""){
          return ""
        } else {
          const aa = b.split("/")
          if(aa.length < 2){
            return ""
          }
          return aa.slice(0,aa.length-1).join("/")
        }
      })
    }
  };
}
